export default "__VITE_ASSET__QUYjFvOt__"